module.exports = __webpack_public_path__ + "static/media/plotter1.88881db5.png";